"use client";
import { useState, useEffect } from "react";
import "../../styles/Analytics.css";
import Header from "../../components/Header/Header.js";
import SearchIcon from "@mui/icons-material/Search";
import sharecomment from "../../assets/Images/ShareComment.png";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import Revenue from "../../assets/Images/revenue.svg";
import Clicks from "../../assets/Images/clicks.svg";
import Referrals from "../../assets/Images/Referrals.svg";
import Payments from "../../assets/Images/payments.svg";
import rightbg from "../../assets/Images/rightbg.svg";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import axios from "axios";
import Cookies from "js-cookie";
import { GetWebAccessToken } from "../../components/ReusebleComponents/ResuseableApiCalls";
import "../../CommonStyle/Tablestyling.css";
import NavigateBeforeIcon from "@mui/icons-material/NavigateBefore";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import { Select, MenuItem } from "@mui/material";

const ProPartnerAnalytics = () => {
  const [theme, setTheme] = useState(localStorage.getItem("theme") || "light");
  const [searchQuery, setSearchQuery] = useState("");
  const [withdrawTransaction, setWithdrawTransaction] = useState({
    paymentsHistory: [],
    distributorsCount: 0,
    withdrawAmount: 0,
    totalPayments: 0,
    revenue: 0,
  });
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const recordsPerPageOptions = [5, 10, 20, 50];
  const totalPages = Math.ceil(
    withdrawTransaction.paymentsHistory.length / itemsPerPage
  );
  const pageNumbers = Array.from({ length: totalPages }, (_, i) => i + 1);
  const startIndex = (currentPage - 1) * itemsPerPage;
  const endIndex = startIndex + itemsPerPage;
  const paginatedData = withdrawTransaction.paymentsHistory.slice(
    startIndex,
    endIndex
  );

  const baseUrl = process.env.REACT_APP_BACKEND_URL;

  useEffect(() => {
    if (theme === "dark") {
      document.body.classList.add("dark-mode");
      document.body.classList.remove("light-mode");
    } else {
      document.body.classList.add("light-mode");
      document.body.classList.remove("dark-mode");
    }
    localStorage.setItem("theme", theme);
  }, [theme]);

  const formatNumber = (num) => {
    if (num === null || num === undefined || isNaN(num)) {
      return "0.00";
    }
    if (num >= 1_000_000) {
      return (num / 1_000_000).toFixed(2) + "M";
    } else if (num >= 1_000) {
      return (num / 1_000).toFixed(2) + "k";
    }
    return num.toFixed(2);
  };

  const handleShare = () => {
    const MerchantId = Cookies.get("MerchantId");
    const message = `Check Out : ${baseUrl}/refer/referralRewards/${MerchantId}`;
    const whatsappUrl = `https://api.whatsapp.com/send?text=${encodeURIComponent(
      message
    )}`;
    window.open(whatsappUrl, "_blank");
  };

  const handleCopy = (copydata) => {
    navigator.clipboard.writeText(copydata || "");
  };

  const ReferralLink = () => {
    const merchantId = Cookies.get("MerchantId");
    const referralUrl = `${baseUrl}/refer/referralRewards/${merchantId}`;

    return (
      <div className="down-link-tag">
        <a href={referralUrl}>{referralUrl}</a>
        <span>
          <ContentCopyIcon
            style={{ color: "#fff" }}
            onClick={() => handleCopy(referralUrl)}
          />
        </span>
      </div>
    );
  };

  const fetchProPartnerAnalytics = async () => {
    const token = await GetWebAccessToken();
    try {
      const Headers = {
        "Content-Type": "application/json",
        "Cache-Control": "no-cache",
    "Pragma": "no-cache",
        Authorization: `Bearer ${token}`,
      };
      const response = await axios.get(
        `${baseUrl}/refer/proPartner/analytics`,
        {
          headers: Headers,
        }
      );

      const responseData = response.data;
      if (responseData?.status) {
        console.log("Pro Partner Analytics data", JSON.stringify(responseData));
        setWithdrawTransaction((prev) => ({
          ...prev,
          paymentsHistory: responseData?.data,
          revenue: Number(responseData?.totalRevenue),
          withdrawAmount: Number(responseData?.totalWithdraw),
          distributorsCount: Number(responseData?.distributors),
          totalPayments: Number(responseData?.totalPayments),
        }));
      }
    } catch (err) {
      console.log("some thing went wrong", err);
    }
  };

  useEffect(() => {
    fetchProPartnerAnalytics();
  }, []);

  const handlePageChange = (page) => {
    setCurrentPage(page);
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  const handlePrevNext = (page) => {
    setCurrentPage(page);
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <>
      <div className="dashboard">
        <div className="dashboard-content-v">
          <Header title="Analytics Dashboard - This month" />
          <div className="inside-bg-analytics">
            <div>
              <div className="dash-grids">
                <div className="stats-grid">
                  <div className="stat-card-1">
                    <div className="stat-header">
                      <img src={Revenue} />
                      <h3>Revenue</h3>
                    </div>
                    <hr className="gradient-line" />
                    <div className="values-full-div">
                      <div className="stat-value">
                        ₹{" "}
                        {formatNumber(
                          withdrawTransaction?.revenue +
                            withdrawTransaction?.withdrawAmount
                        )}
                      </div>
                    </div>
                  </div>

                  <div className="stat-card-2">
                    <div className="stat-header">
                      <img src={Clicks} />
                      <h3>Previous Withdraw</h3>
                    </div>
                    <hr className="gradient-line" />
                    <div className="values-full-div">
                      <div className="stat-value">
                        ₹{" "}
                        {formatNumber(withdrawTransaction?.withdrawAmount || 0)}
                      </div>
                    </div>
                  </div>

                  <div className="stat-card-3">
                    <div className="stat-header">
                      <img src={Referrals} />
                      <h3>Distributors</h3>
                    </div>
                    <hr className="gradient-line" />
                    <div className="values-full-div">
                      <div className="stat-value">
                        {withdrawTransaction?.distributorsCount} No's
                      </div>
                    </div>
                  </div>

                  <div className="stat-card-4">
                    <div className="stat-header">
                      <img src={Payments} />
                      <h3>Payments</h3>
                    </div>
                    <hr className="gradient-line" />
                    <div className="values-full-div">
                      <div className="stat-value">
                        ₹ {formatNumber(withdrawTransaction?.totalPayments)}
                      </div>
                    </div>
                  </div>
                </div>

                <div className="stats-grid-right">
                  <div className="rightbg-container">
                    <img
                      src={rightbg}
                      className="rightbg-image"
                      alt="Background"
                    />
                  </div>
                  <div className="right-upper-one">
                    <p className="right-inside-text-v">
                      Share the link directly with your customer, through a
                      Whatsapp group, or publicly.
                    </p>
                    <img
                      className="rightside-img"
                      src={sharecomment}
                      alt="Share Comment"
                    />
                  </div>
                  <div className="media-links-ellipses">
                    {ReferralLink()}
                    <div className="media-row-column-v">
                      <div className="ellipse-for-links-w">
                        <WhatsAppIcon
                          onClick={() => handleShare()}
                          style={{ color: "var(--white)", fontSize: "2rem" }}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="payments-section">
                <div className="section-header">
                  <div className="search-container">
                    <SearchIcon
                      style={{ color: "var(--thirdshade-orange)" }}
                      className="search-icon"
                    />
                    <input
                      type="text"
                      value={searchQuery}
                      placeholder="Search here"
                      className="search"
                      onChange={(e) => setSearchQuery(e.target.value)}
                    />
                  </div>
                </div>

                <div className="tabs-table-container-payouts">
                  <div className="common-table-v">
                    <table>
                      <thead className="AN-table-header">
                        <tr>
                          <th
                            style={{ textAlign: "left" }}
                            className="AN-each-td"
                          >
                            Transaction Id
                          </th>
                          <th className="AN-each-td">Account Name</th>
                          <th className="AN-each-td">Account No</th>
                          <th className="AN-each-td">IFSC Code</th>
                          <th className="AN-each-td">Withdraw Amount</th>
                          <th className="AN-each-td analytic-tds-th">TDS</th>
                          <th className="AN-each-td">Credited</th>
                          <th className="AN-each-td">Date</th>
                          <th className="AN-each-td">Status</th>
                        </tr>
                      </thead>
                      <tbody>
                        {paginatedData?.length > 0 &&
                          paginatedData?.map((eachTrnx, trnxIndex) => {
                            const dateParts =
                              eachTrnx?.transactionDate?.split("/");
                            const formattedDate =
                              dateParts && dateParts.length === 3
                                ? `${dateParts[1]}/${dateParts[0]}/${dateParts[2]}`
                                : "N/A";

                            const timeParts = eachTrnx?.transactionTime
                              ? eachTrnx?.transactionTime.split(" ")
                              : null;
                            const formattedTime = timeParts
                              ? timeParts[0] + " " + timeParts[1]
                              : "N/A";

                            const creditedAmount =
                              isNaN(parseFloat(eachTrnx?.actualAmount)) ||
                              isNaN(parseFloat(eachTrnx?.TDSCharges))
                                ? "N/A"
                                : (
                                    parseFloat(eachTrnx?.actualAmount) -
                                    parseFloat(eachTrnx?.TDSCharges)
                                  ).toFixed(2);

                            return (
                              <tr className="AN-table-tr" key={trnxIndex}>
                                <td
                                  className="AN-each-td truncated-text"
                                  title={eachTrnx?.transactionId}
                                >
                                  {eachTrnx?.transactionId?.slice(0, 14)}...
                                </td>
                                <td className="AN-each-td">
                                  {eachTrnx?.beneficiaryName || "N/A"}
                                </td>
                                <td className="AN-each-td">
                                  {eachTrnx?.payOutAccountNumber || "N/A"}
                                </td>
                                <td className="AN-each-td">
                                  {eachTrnx?.payOutIFSCNumber || "N/A"}
                                </td>
                                <td className="AN-each-td">
                                  {isNaN(parseFloat(eachTrnx?.actualAmount))
                                    ? "N/A"
                                    : parseFloat(
                                        eachTrnx?.actualAmount
                                      ).toFixed(2)}
                                </td>
                                <td className="AN-each-td">
                                  {eachTrnx?.TDSPercentage
                                    ? `${eachTrnx?.TDSPercentage} %`
                                    : "N/A"}
                                </td>
                                <td className="AN-each-td">{creditedAmount}</td>
                                <td className="AN-each-td">
                                  {formattedDate} - {formattedTime}
                                </td>
                                <td className="status-AN-each-td">
                                  <span
                                    className={`status-${
                                      eachTrnx?.status?.toLowerCase() ===
                                      "success"
                                        ? "success"
                                        : eachTrnx?.status?.toLowerCase() ===
                                          "processing"
                                        ? "processing"
                                        : ""
                                    }`}
                                  >
                                    {eachTrnx?.status || "N/A"}
                                  </span>
                                </td>
                              </tr>
                            );
                          })}
                      </tbody>
                    </table>
                  </div>
                  {withdrawTransaction?.paymentsHistory?.length > 0 && (
                    <div className="pagination-controls">
                      <div>
                        <Select
                          value={itemsPerPage}
                          onChange={(e) => {
                            setItemsPerPage(e.target.value);
                            setCurrentPage(1);
                            window.scrollTo({ top: 0, behavior: "smooth" });
                          }}
                          className="itemsperpage"
                        >
                          {recordsPerPageOptions.map((option) => (
                            <MenuItem key={option} value={option}>
                              {option}
                            </MenuItem>
                          ))}
                        </Select>
                      </div>

                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: 8,
                        }}
                      >
                        <button
                          disabled={currentPage === 1}
                          onClick={() =>
                            handlePrevNext(Math.max(1, currentPage - 1))
                          }
                          style={{
                            background: "none",
                            border: "none",
                            cursor:
                              currentPage === 1 ? "not-allowed" : "pointer",
                            opacity: currentPage === 1 ? 0.5 : 1,
                          }}
                        >
                          <NavigateBeforeIcon sx={{ fontSize: 18 }} />
                        </button>

                        {pageNumbers.map((page) => (
                          <button
                            key={page}
                            onClick={() => handlePageChange(page)}
                            style={{
                              padding: "6px 12px",
                              borderRadius: "8px",
                              border: "none",
                              backgroundColor:
                                currentPage === page
                                  ? "rgba(0, 123, 255, 0.2)"
                                  : "#ccc",
                              color: currentPage === page ? "#000" : "#fff",
                              fontWeight:
                                currentPage === page ? "bold" : "normal",
                              cursor: "pointer",
                            }}
                          >
                            {page}
                          </button>
                        ))}

                        <button
                          disabled={currentPage === totalPages}
                          onClick={() =>
                            handlePrevNext(
                              Math.min(totalPages, currentPage + 1)
                            )
                          }
                          style={{
                            background: "none",
                            border: "none",
                            cursor:
                              currentPage === totalPages
                                ? "not-allowed"
                                : "pointer",
                            opacity: currentPage === totalPages ? 0.5 : 1,
                          }}
                        >
                          <NavigateNextIcon sx={{ fontSize: 18 }} />
                        </button>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ProPartnerAnalytics;
